import dayjs from "dayjs";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

export const ExportCSV = (csvData, fileName = "tamata") => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".csv";
  try {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "csv", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(
      data,
      fileName + dayjs(new Date()).format("YYYY-MM-DD") + fileExtension
    );
  } catch (error) {
    console.log(error);
    return;
  }
};